// 선 아이콘: 24칸 기준, 선 굵기 1.75, currentColor. 이 앱용으로 그린 단순 도형이다.
// lib.ts 가 이 파일을 불러 쓰므로, 고리가 생기지 않게 이 파일은 lib.ts 를 불러오지 않는다.

const span = (cls: string) => {
  const s = document.createElement("span");
  s.className = cls;
  return s;
};

const P = {
  plus: '<path d="M12 5v14M5 12h14"/>',
  x: '<path d="M6 6l12 12M18 6L6 18"/>',
  check: '<path d="M5 12.5l4.5 4.5L19 7"/>',
  "check-circle": '<circle cx="12" cy="12" r="9"/><path d="M8 12.3l2.7 2.7L16 9.7"/>',
  "chevron-left": '<path d="M15 6l-6 6 6 6"/>',
  "chevron-right": '<path d="M9 6l6 6-6 6"/>',
  "chevron-down": '<path d="M6 9l6 6 6-6"/>',
  more: '<circle cx="5.5" cy="12" r="1.3" fill="currentColor" stroke="none"/><circle cx="12" cy="12" r="1.3" fill="currentColor" stroke="none"/><circle cx="18.5" cy="12" r="1.3" fill="currentColor" stroke="none"/>',
  sparkles: '<path d="M12 3.5l1.6 4.4 4.4 1.6-4.4 1.6L12 15.5l-1.6-4.4L6 9.5l4.4-1.6z"/><path d="M18.5 15v4M16.5 17h4"/>',
  cube: '<path d="M12 3l8 4.5v9L12 21l-8-4.5v-9z"/><path d="M4 7.5l8 4.5 8-4.5M12 12v9"/>',
  image: '<rect x="3.5" y="4.5" width="17" height="15" rx="2"/><circle cx="9" cy="10" r="1.6"/><path d="M20.5 16l-5-5-8.5 8.5"/>',
  upload: '<path d="M12 20V9M7 14l5-5 5 5M5 4h14"/>',
  download: '<path d="M12 4v11M7 10l5 5 5-5M5 20h14"/>',
  camera: '<path d="M4 8.5h3l1.5-2.5h7L17 8.5h3v10.5H4z"/><circle cx="12" cy="13.5" r="3.5"/>',
  pencil: '<path d="M4 20l1-4.5L15.5 5a2.1 2.1 0 013 3L8 18.5z"/><path d="M13.5 7l3 3"/>',
  trash: '<path d="M4.5 7h15M9.5 7V4.5h5V7M6.5 7l1 13h9l1-13"/>',
  eye: '<path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z"/><circle cx="12" cy="12" r="3"/>',
  maximize: '<path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/>',
  layers: '<path d="M12 3.5l9 4.5-9 4.5-9-4.5z"/><path d="M3 12l9 4.5 9-4.5M3 16l9 4.5 9-4.5"/>',
  monitor: '<rect x="3" y="4.5" width="18" height="12" rx="1.5"/><path d="M9 20h6M12 16.5V20"/>',
  refresh: '<path d="M20 11a8 8 0 00-14.3-4.5L4 8.5"/><path d="M4 4v4.5h4.5"/><path d="M4 13a8 8 0 0014.3 4.5l1.7-2"/><path d="M20 20v-4.5h-4.5"/>',
  alert: '<path d="M12 4L2.8 19.5h18.4z"/><path d="M12 10v4.5M12 17.2v.3"/>',
  info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v5.5M12 7.8v.3"/>',
  help: '<circle cx="12" cy="12" r="9"/><path d="M9.6 9.5a2.5 2.5 0 114 2c-.9.6-1.6 1.1-1.6 2.2M12 16.8v.3"/>',
  clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.5 2"/>',
  star: '<path d="M12 3.8l2.5 5.2 5.7.7-4.2 3.9 1.1 5.6L12 16.4l-5.1 2.8 1.1-5.6-4.2-3.9 5.7-.7z"/>',
  coins: '<ellipse cx="12" cy="7" rx="7" ry="3"/><path d="M5 7v5c0 1.7 3.1 3 7 3s7-1.3 7-3V7M5 12v5c0 1.7 3.1 3 7 3s7-1.3 7-3v-5"/>',
  logout: '<path d="M14 4.5h4.5a1.5 1.5 0 011.5 1.5v12a1.5 1.5 0 01-1.5 1.5H14M10 16l-4-4 4-4M6 12h10"/>',
  shield: '<path d="M12 3.5l7.5 3v5.5c0 4.5-3.2 7.8-7.5 9-4.3-1.2-7.5-4.5-7.5-9V6.5z"/>',
  grid: '<rect x="4" y="4" width="7" height="7" rx="1.5"/><rect x="13" y="4" width="7" height="7" rx="1.5"/><rect x="4" y="13" width="7" height="7" rx="1.5"/><rect x="13" y="13" width="7" height="7" rx="1.5"/>',
  stage: '<path d="M3 18h18M5 18v-6h14v6M8 12V8h8v4"/>',
  "list-check": '<path d="M10 6.5h10M10 12h10M10 17.5h10"/><path d="M3.5 6.5l1.5 1.5 2.5-2.5M3.5 12l1.5 1.5L7.5 11M3.5 17.5l1.5 1.5 2.5-2.5"/>',
  film: '<rect x="3.5" y="6" width="17" height="13" rx="1.5"/><path d="M3.5 10h17M8 6l2 4M13 6l2 4"/>',
  users: '<circle cx="9" cy="8.5" r="3.5"/><path d="M2.5 19.5c.6-3.4 3.2-5.5 6.5-5.5s5.9 2.1 6.5 5.5"/><path d="M15.5 5.2a3.5 3.5 0 010 6.6M17.5 14.3c2.2.6 3.6 2.6 4 5.2"/>',
  calendar: '<rect x="3.5" y="5" width="17" height="15.5" rx="2"/><path d="M3.5 10h17M8 3v4M16 3v4"/>',
  pause: '<path d="M9 6v12M15 6v12"/>',
  play: '<path d="M8 5.5v13l10.5-6.5z"/>',
} as const;

export type IconName = keyof typeof P;

/** 장식용이면 label 없이, 혼자 뜻을 전하면 label 을 준다 */
export function icon(name: IconName, size = 18, label?: string): HTMLElement {
  const s = span("i");
  if (label) {
    s.setAttribute("role", "img");
    s.setAttribute("aria-label", label);
  } else s.setAttribute("aria-hidden", "true");
  s.innerHTML = `<svg viewBox="0 0 24 24" width="${size}" height="${size}" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">${P[name]}</svg>`;
  return s;
}

/**
 * 머리띠·로그인 로고 '교차 X' (브랜딩/logo-final/brandmark-snippet.txt 그대로).
 * 64 격자라 16·32·48px 에서 획 끝이 픽셀에 맞는다 — 머리띠 32, 로그인 48 로 쓴다.
 * tone "dark" 는 어두운 바탕 위에서 타일을 한 단계 띄운다(mark-dark.svg, #232932).
 */
export function brandMark(size = 32, tone: "light" | "dark" = "light"): HTMLElement {
  const s = span("brand-mark");
  s.setAttribute("aria-hidden", "true");
  const tile = tone === "dark" ? "#232932" : "#151a21";
  s.innerHTML = `<svg viewBox="0 0 64 64" width="${size}" height="${size}" aria-hidden="true" focusable="false"><rect width="64" height="64" rx="14" fill="${tile}"/><path d="M12 18.7A0.9 0.9 0 0 0 12.26 19.33L22.17 29.24A0.9 0.9 0 0 0 23.44 29.24L29.24 23.44A0.9 0.9 0 0 0 29.24 22.17L19.33 12.26A0.9 0.9 0 0 0 18.7 12L12.9 12A0.9 0.9 0 0 0 12 12.9ZM34.76 40.56A0.9 0.9 0 0 0 34.76 41.83L44.67 51.74A0.9 0.9 0 0 0 45.3 52L51.1 52A0.9 0.9 0 0 0 52 51.1L52 45.3A0.9 0.9 0 0 0 51.74 44.67L41.83 34.76A0.9 0.9 0 0 0 40.56 34.76Z" fill="#7482f2"/><path d="M45.3 12A0.9 0.9 0 0 0 44.67 12.26L12.26 44.67A0.9 0.9 0 0 0 12 45.3L12 51.1A0.9 0.9 0 0 0 12.9 52L18.7 52A0.9 0.9 0 0 0 19.33 51.74L51.74 19.33A0.9 0.9 0 0 0 52 18.7L52 12.9A0.9 0.9 0 0 0 51.1 12Z" fill="#4fd1c5"/></svg>`;
  return s;
}

// 글자 로고 'STAGE X' (logo-final/wordmark-light.svg · wordmark-dark.svg). 어두운 판은 획이 조금 가늘다.
const WORDMARK = {
  light: {
    ink: "#151a21",
    p1: "#4b5bd0",
    p2: "#23807a",
    paths: [
      '<path d="M31.53 0L31.53 6.9L10 6.9A2.4 3.1 0 0 0 7.6 10L7.6 12.65A2.4 3.5 0 0 0 10 16.15L22.5 16.15A10 10 0 0 1 32.5 26.15L32.5 30A10 10 0 0 1 22.5 40L0 40L0 33.1L22.5 33.1A2.4 3.1 0 0 0 24.9 30L24.9 26.15A2.4 3.5 0 0 0 22.5 22.65L10 22.65A10 10 0 0 1 0 12.65L0 10A10 10 0 0 1 10 0Z"/>',
      '<path transform="translate(39.3 0)" d="M0 0L32.5 0L32.5 6.9L20.05 6.9L20.05 40L12.45 40L12.45 6.9L0 6.9Z"/>',
      '<path transform="translate(73 0)" d="M0 40L15.6 0L20.4 0L36 40L28.27 40L25.03 31.7L10.97 31.7L7.73 40ZM13.5 25.2L22.5 25.2L18 13.66Z" fill-rule="evenodd"/>',
      '<path transform="translate(115.8 0)" d="M34.5 0L34.5 6.9L10 6.9A2.4 3.1 0 0 0 7.6 10L7.6 30A2.4 3.1 0 0 0 10 33.1L24.5 33.1A2.4 3.1 0 0 0 26.9 30L26.9 24.9L18.25 24.9L18.25 18.4L34.5 18.4L34.5 30A10 10 0 0 1 24.5 40L10 40A10 10 0 0 1 0 30L0 10A10 10 0 0 1 10 0Z"/>',
      '<path transform="translate(158.9 0)" d="M0 0L28.5 0L28.5 6.9L7.6 6.9L7.6 16.25L26.9 16.25L26.9 22.75L7.6 22.75L7.6 33.1L29.07 33.1L29.07 40L0 40Z"/>',
    ],
    x1: "M0.57 0A0.3 0.3 0 0 0 0.32 0.47L12.06 17.52A0.3 0.3 0 0 0 12.56 17.52L16.93 11.17A0.3 0.3 0 0 0 16.93 10.83L9.56 0.13A0.3 0.3 0 0 0 9.31 0ZM20.07 28.83A0.3 0.3 0 0 0 20.07 29.17L27.44 39.87A0.3 0.3 0 0 0 27.69 40L36.43 40A0.3 0.3 0 0 0 36.68 39.53L24.94 22.48A0.3 0.3 0 0 0 24.44 22.48Z",
    x2: "M27.69 0A0.3 0.3 0 0 0 27.44 0.13L0.32 39.53A0.3 0.3 0 0 0 0.57 40L9.31 40A0.3 0.3 0 0 0 9.56 39.87L36.68 0.47A0.3 0.3 0 0 0 36.43 0Z",
  },
  dark: {
    ink: "#f5f6f8",
    p1: "#7482f2",
    p2: "#4fd1c5",
    paths: [
      '<path d="M31.53 0L31.53 6.59L10 6.59A2.75 3.42 0 0 0 7.25 10L7.25 12.49A2.75 3.82 0 0 0 10 16.31L22.5 16.31A10 10 0 0 1 32.5 26.31L32.5 30A10 10 0 0 1 22.5 40L0 40L0 33.42L22.5 33.42A2.75 3.42 0 0 0 25.25 30L25.25 26.31A2.75 3.82 0 0 0 22.5 22.49L10 22.49A10 10 0 0 1 0 12.49L0 10A10 10 0 0 1 10 0Z"/>',
      '<path transform="translate(39.3 0)" d="M0 0L32.5 0L32.5 6.59L19.88 6.59L19.88 40L12.63 40L12.63 6.59L0 6.59Z"/>',
      '<path transform="translate(73 0)" d="M0 40L15.6 0L20.4 0L36 40L28.65 40L25.29 31.39L10.71 31.39L7.35 40ZM13.12 25.2L22.88 25.2L18 12.7Z" fill-rule="evenodd"/>',
      '<path transform="translate(115.8 0)" d="M34.5 0L34.5 6.59L10 6.59A2.75 3.42 0 0 0 7.25 10L7.25 30A2.75 3.42 0 0 0 10 33.42L24.5 33.42A2.75 3.42 0 0 0 27.25 30L27.25 24.58L18.25 24.58L18.25 18.4L34.5 18.4L34.5 30A10 10 0 0 1 24.5 40L10 40A10 10 0 0 1 0 30L0 10A10 10 0 0 1 10 0Z"/>',
      '<path transform="translate(158.9 0)" d="M0 0L28.5 0L28.5 6.59L7.25 6.59L7.25 16.41L26.9 16.41L26.9 22.59L7.25 22.59L7.25 33.42L29.07 33.42L29.07 40L0 40Z"/>',
    ],
    x1: "M0.58 0A0.3 0.3 0 0 0 0.33 0.47L12.14 17.4A0.3 0.3 0 0 0 12.63 17.4L16.81 11.41A0.3 0.3 0 0 0 16.81 11.07L9.17 0.13A0.3 0.3 0 0 0 8.93 0ZM20.19 28.59A0.3 0.3 0 0 0 20.19 28.93L27.83 39.87A0.3 0.3 0 0 0 28.07 40L36.42 40A0.3 0.3 0 0 0 36.67 39.53L24.86 22.6A0.3 0.3 0 0 0 24.37 22.6Z",
    x2: "M28.07 0A0.3 0.3 0 0 0 27.83 0.13L0.33 39.53A0.3 0.3 0 0 0 0.58 40L8.93 40A0.3 0.3 0 0 0 9.17 39.87L36.67 0.47A0.3 0.3 0 0 0 36.42 0Z",
  },
} as const;

/** 글자 로고 'STAGE X'. height 는 대문자 높이(px). 화면 읽기 프로그램에는 "STAGE X" 로 읽힌다 */
export function brandWordmark(height = 14, tone: "light" | "dark" = "light"): HTMLElement {
  const w = WORDMARK[tone];
  const s = span("brand-word");
  s.setAttribute("role", "img");
  s.setAttribute("aria-label", "STAGE X");
  const width = Math.round(((height * 243.97) / 40) * 100) / 100;
  s.innerHTML = `<svg viewBox="0 0 243.97 40" width="${width}" height="${height}" aria-hidden="true" focusable="false"><g fill="${w.ink}">${w.paths.join("")}</g><g transform="translate(206.97 0)"><path d="${w.x1}" fill="${w.p1}"/><path d="${w.x2}" fill="${w.p2}"/></g></svg>`;
  return s;
}

/** 정식 표기 'STAGE X · 아트웍': 글자 로고 + 회색 가운뎃점 + '아트웍' */
export function brandName(height = 14, tone: "light" | "dark" = "light"): HTMLElement {
  const s = span("name");
  const dot = span("dot");
  dot.setAttribute("aria-hidden", "true");
  const sub = span("sub");
  sub.textContent = "아트웍";
  s.append(brandWordmark(height, tone), dot, sub);
  return s;
}
